export const paginationProperties = {
  pageSizes: [5, 15, 25, 50, 100],
  layout: 'total, sizes, prev, pager, next, jumper',
};

export const DEFAULT_LIMIT = 25;
export const DEFAULT_MAX_LIMIT = 1000;

export const DEFAULT_OFFSET = 0;

export const DEFAULT_PAGE_SIZE_LIST = [25, 50, 100, 500];

export const ACCEPTED_FILE_EXTENSIONS = 'text/csv, text/plain';

export const DEFAULT_PAGE_NUMBER = 1;

export const MIN_DEFAULT_LIMIT = 5;

export const PAGINATION_DEFAULT_PAGE_SIZE = 100;
